// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../utils/Utils.bs.js");
let React = require("react");
let Sentry = require("../Sentry.bs.js");
let Belt_List = require("@rescript/runtime/lib/js/Belt_List.js");
let AuthSession = require("../../utils/AuthSession.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let FeaturesV3_EvaluateFlagsV5Mutation_graphql = require("../../__generated__/FeaturesV3_EvaluateFlagsV5Mutation_graphql.bs.js");

let features = {
  hd: [
    "BillingPreferencePlanDowngrade",
    "billing_preference_plan_downgrade"
  ],
  tl: {
    hd: [
      "AnonymousBroadcastProperties",
      "anonymous_broadcast_properties"
    ],
    tl: {
      hd: [
        "CancelProMembership",
        "cancel_pro_membership"
      ],
      tl: {
        hd: [
          "ConversationMessageStatus",
          "conversation_message_status"
        ],
        tl: {
          hd: [
            "DuplicateListings",
            "duplicate_listings"
          ],
          tl: {
            hd: [
              "MLSCheckboxesAlwaysEnabled",
              "mls_checkboxes_always_enabled"
            ],
            tl: {
              hd: [
                "SaveAsBuyer",
                "save_as_buyer"
              ],
              tl: {
                hd: [
                  "SetConversationAnonymousStatus",
                  "set_conversation_anonymous_status"
                ],
                tl: {
                  hd: [
                    "ValidatePersonalInfoInDescription",
                    "validate_personal_info_in_description"
                  ],
                  tl: {
                    hd: [
                      "HiddenSellers",
                      "hidden_sellers"
                    ],
                    tl: {
                      hd: [
                        "UnhideSeller",
                        "unhide_seller"
                      ],
                      tl: {
                        hd: [
                          "CAP_ClientRegistration",
                          "cap_client_registration"
                        ],
                        tl: {
                          hd: [
                            "SavedSearches",
                            "saved_searches"
                          ],
                          tl: {
                            hd: [
                              "RenameClient",
                              "rename_client"
                            ],
                            tl: {
                              hd: [
                                "OffMlsFilterForCAP",
                                "off_mls_filter_for_cap"
                              ],
                              tl: {
                                hd: [
                                  "MarketingProfileSettings",
                                  "marketing_profile_settings"
                                ],
                                tl: {
                                  hd: [
                                    "SwitchTeamToAgentMarketingProfile",
                                    "switch_team_to_agent_marketing_profile"
                                  ],
                                  tl: {
                                    hd: [
                                      "CheckPropertyStatusOnMLS",
                                      "check_property_status_on_mls"
                                    ],
                                    tl: {
                                      hd: [
                                        "UseNewGoogleMaps",
                                        "use_new_google_maps"
                                      ],
                                      tl: {
                                        hd: [
                                          "UseNewPropertiesUpdatedSort",
                                          "use_new_properties_updated_sort"
                                        ],
                                        tl: {
                                          hd: [
                                            "SharedPropertyDrafts",
                                            "shared_property_drafts"
                                          ],
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function fromString(v) {
  return Belt_List.getAssoc(Stdlib_List.map(features, param => [
    param[1],
    param[0]
  ]), v, (prim0, prim1) => prim0 === prim1);
}

function key(t) {
  return Stdlib_Option.getOrThrow(Belt_List.getAssoc(features, t, (prim0, prim1) => prim0 === prim1), undefined);
}

let allKeys = Stdlib_List.map(features, param => param[1]);

let Feature = {
  features: features,
  fromString: fromString,
  key: key,
  allKeys: allKeys
};

let overrides = (JSON.parse(process.env.NEXT_PUBLIC__FEATURES__));

function get(extra) {
  return overrides[extra];
}

function override(param) {
  let feature = param[0];
  let override$1 = overrides[key(feature)];
  return [
    feature,
    Stdlib_Option.isSome(override$1) ? override$1 : param[1]
  ];
}

let x = Stdlib_List.fromArray(Utils.$$Array.stripNones(Object.keys(overrides).map(k => {
  let f = fromString(k);
  return Stdlib_Option.map(f, f$p => [
    f$p,
    overrides[k]
  ]);
})));

let $$default = Stdlib_List.length(x) > 0 ? x : undefined;

let Override = {
  overrides: overrides,
  get: get,
  override: override,
  $$default: $$default
};

function variant(f, t) {
  return Stdlib_Option.flatMap(Belt_List.getAssoc(t, f, (prim0, prim1) => prim0 === prim1), x => x);
}

function make(jsProps) {
  return Stdlib_List.fromArray(Stdlib_Array.filterMap(jsProps, e => {
    let flagKey = fromString(e.flagKey);
    if (flagKey !== undefined) {
      return [
        flagKey,
        e.variantKey
      ];
    }
  }));
}

let Features = {
  variant: variant,
  make: make
};

let context = React.createContext(undefined);

function useFeatureFlipper(flagKey) {
  let features = React.useContext(context);
  return Stdlib_Option.flatMap(features, extra => variant(flagKey, extra));
}

let convertVariables = FeaturesV3_EvaluateFlagsV5Mutation_graphql.Internal.convertVariables;

let convertResponse = FeaturesV3_EvaluateFlagsV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = FeaturesV3_EvaluateFlagsV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, FeaturesV3_EvaluateFlagsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, FeaturesV3_EvaluateFlagsV5Mutation_graphql.node, convertResponse, convertWrapRawResponse);

let EvaluateFlagsV5Mutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

let make$1 = context.Provider;

let Provider = {
  make: make$1
};

function FeaturesV3$Provider(props) {
  let match = use();
  let mutate = match[0];
  let match$1 = React.useState(() => {});
  let setFeatures = match$1[1];
  let features = match$1[0];
  let authSession = AuthSession.use();
  let refresh = React.useCallback(() => mutate({
    keys: Stdlib_List.toArray(allKeys)
  }, undefined, undefined, undefined, (response, _mutationErrors) => {
    let flags = response.evaluateFlagsV5;
    if (flags === undefined) {
      return setFeatures(param => {});
    }
    let features = make(Stdlib_Array.keepSome(flags));
    setFeatures(param => features);
  }, e => {
    Sentry.captureException(new Error(e.message), "FeaturesV3.res", 151, {
      exn: e
    }, undefined);
    setFeatures(param => {});
  }, undefined), [mutate]);
  let token = authSession !== undefined && authSession.__typename === "AuthSession" ? authSession.token : undefined;
  React.useEffect(() => {
    let disposable = refresh();
    return () => {
      disposable.dispose();
    };
  }, [token]);
  let features$1 = React.useMemo(() => {
    let features$2 = Stdlib_Option.map(features, x => Stdlib_List.map(x, override));
    if (Stdlib_Option.isSome(features$2)) {
      return features$2;
    } else {
      return $$default;
    }
  }, [features]);
  return JsxRuntime.jsx(make$1, {
    value: features$1,
    children: props.children
  });
}

let Provider$1 = {
  Provider: Provider,
  make: FeaturesV3$Provider
};

let JsProvider = {
  make: FeaturesV3$Provider
};

function useSavedSearchesEnabled() {
  return useFeatureFlipper("SavedSearches") === "on";
}

exports.Feature = Feature;
exports.Override = Override;
exports.Features = Features;
exports.context = context;
exports.useFeatureFlipper = useFeatureFlipper;
exports.EvaluateFlagsV5Mutation = EvaluateFlagsV5Mutation;
exports.Provider = Provider$1;
exports.JsProvider = JsProvider;
exports.useSavedSearchesEnabled = useSavedSearchesEnabled;
/* allKeys Not a pure module */
